import { useAuth } from '../auth/AuthContext'
import { navigate, type Route } from '../App'
import { colors } from '../theme'

// Brand-prescribed nav bar: Master Purple bg, 52px height, white links
// at 11px / 700 / 1.2px tracking / uppercase, active state with a 3px
// white bottom border.
const NAV_HEIGHT = 52

export default function TopBar({ route }: { route: Route }) {
  const { user, signOut } = useAuth()
  return (
    <header
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 10,
        background: colors.purple,
        color: colors.white,
        height: NAV_HEIGHT,
        boxShadow: '0 2px 8px rgba(35,31,32,0.08)',
      }}
    >
      <div
        style={{
          maxWidth: 1200,
          margin: '0 auto',
          height: '100%',
          padding: '0 24px',
          display: 'flex',
          alignItems: 'center',
          gap: 24,
        }}
      >
        <button
          onClick={() => navigate({ name: 'dashboard' })}
          aria-label="Parkify Sales — Dashboard"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 14,
            background: 'transparent',
            border: 'none',
            color: colors.white,
            padding: 0,
            height: '100%',
            cursor: 'pointer',
          }}
        >
          <img
            src="/parkify-logo-white.svg"
            alt="Parkify"
            // 28×~7px proportional to the 129.21×30.85 viewBox
            style={{ height: 22, width: 'auto', display: 'block' }}
          />
          <span
            style={{
              fontSize: 11,
              fontWeight: 700,
              letterSpacing: '2px',
              textTransform: 'uppercase',
              color: colors.white,
              borderLeft: '1px solid rgba(255,255,255,0.45)',
              paddingLeft: 12,
              lineHeight: 1,
            }}
          >
            Sales
          </span>
        </button>

        <nav style={{ display: 'flex', gap: 4, marginLeft: 20, height: '100%' }}>
          {/* Three tabs: Dashboard | Proposals | Sequences. Child
              routes ("New proposal", "Prospect", individual sequence
              and proposal detail pages) light up their parent tab
              instead of needing their own slot. */}
          <NavLink
            label="Dashboard"
            active={route.name === 'dashboard'}
            onClick={() => navigate({ name: 'dashboard' })}
          />
          <NavLink
            label="Proposals"
            active={
              route.name === 'proposals' ||
              route.name === 'detail' ||
              route.name === 'new'
            }
            onClick={() => navigate({ name: 'proposals' })}
          />
          <NavLink
            label="Sequences"
            active={
              route.name === 'sequences' ||
              route.name === 'sequence-new' ||
              route.name === 'sequence-detail' ||
              route.name === 'prospect'
            }
            onClick={() => navigate({ name: 'sequences' })}
          />
        </nav>

        <div style={{ flex: 1 }} />

        <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
          {user?.picture ? (
            <img
              src={user.picture}
              alt=""
              width={28}
              height={28}
              style={{
                borderRadius: '50%',
                border: `1px solid rgba(255,255,255,0.4)`,
              }}
            />
          ) : (
            <div
              aria-hidden
              style={{
                width: 28,
                height: 28,
                borderRadius: '50%',
                background: 'rgba(255,255,255,0.18)',
                color: colors.white,
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 12,
                fontWeight: 700,
              }}
            >
              {(user?.name ?? user?.email ?? '?').slice(0, 1).toUpperCase()}
            </div>
          )}
          <div
            style={{
              fontSize: 11,
              color: 'rgba(255,255,255,0.85)',
              textAlign: 'right',
              lineHeight: 1.35,
            }}
          >
            <div style={{ color: colors.white, fontWeight: 700 }}>
              {user?.name ?? user?.email}
            </div>
            <div style={{ opacity: 0.75 }}>{user?.email}</div>
          </div>
          <button
            onClick={signOut}
            style={{
              background: 'transparent',
              border: `1px solid rgba(255,255,255,0.4)`,
              color: colors.white,
              borderRadius: 999,
              padding: '5px 14px',
              fontSize: 10,
              fontWeight: 700,
              letterSpacing: '1.2px',
              textTransform: 'uppercase',
              cursor: 'pointer',
            }}
          >
            Sign out
          </button>
        </div>
      </div>
    </header>
  )
}

function NavLink({
  label,
  active,
  onClick,
}: {
  label: string
  active: boolean
  onClick: () => void
}) {
  return (
    <button
      onClick={onClick}
      style={{
        background: 'transparent',
        color: active ? colors.white : 'rgba(255,255,255,0.7)',
        border: 'none',
        borderBottom: `3px solid ${active ? colors.white : 'transparent'}`,
        padding: '0 14px',
        height: '100%',
        fontSize: 11,
        fontWeight: 700,
        letterSpacing: '1.2px',
        textTransform: 'uppercase',
        cursor: 'pointer',
      }}
    >
      {label}
    </button>
  )
}
